import SkeletonWrapper from "~components/SkeletonWrapper"
import { StatementLoader } from "~components/portfolio/styled/portfolio"

const BrokerStatementLoader = () => {
  return (
    <StatementLoader>
      <SkeletonWrapper isLoading={true} width={300} count={1} height={10} />
      <SkeletonWrapper isLoading={true} width={300} count={1} height={10} />
    </StatementLoader>
  )
}

export default BrokerStatementLoader
